module.exports = __webpack_public_path__ + "img/chatbotspl_logo_dark.a3f91e5e.png";